export enum EEventsPerm {
    EVENTS_VIEW = 'events_view',
    EVENTS_EDIT = 'events_edit',
    EVENTS_DELETE = 'events_delete'
}
